<template>
  <Modal
    v-model="visible"
    :title="modalTitle"
    @on-cancel="handleCancel"
    :mask-closable="false"
    width="700"
  >
    <Form v-if="visible" :model="formData" :label-width="120" ref="formRef">
      <FormItem
        label="弹窗类型"
        prop="type"
        :rules="[
          {
            required: true,
            type: 'number',
            message: '请选择弹窗类型',
            trigger: 'change'
          }
        ]"
      >
        <Select
          :disabled="!!formData.id || readonly"
          v-model="formData.type"
          placeholder="请选择弹窗类型"
          @on-change="handleTypeChange"
        >
          <Option :value="1">折扣弹窗</Option>
          <Option :value="2">剧集推荐弹窗</Option>
          <Option :value="3">登录弹窗</Option>
          <Option :value="4">观看激励视频</Option>
          <Option :value="5">自定义弹窗</Option>
          <Option :value="6">通知弹窗</Option>
        </Select>
      </FormItem>

      <!-- 折扣弹窗 (1) -->
      <template v-if="formData.type === 1">
        <FormItem
          label="操作系统"
          prop="deviceSys"
          :rules="[
            {
              required: true,
              type: 'number',
              message: '请选择操作系统',
              trigger: 'change'
            }
          ]"
        >
          <RadioGroup
            v-model="formData.deviceSys"
            type="button"
            @on-change="
              paymentOptions = []
              fetchGoods()
            "
          >
            <Radio :disabled="readonly" :label="0">iOS</Radio>
            <Radio :disabled="readonly" :label="1">Android</Radio>
          </RadioGroup>
        </FormItem>

        <FormItem
          label="折扣内容"
          prop="goodsType"
          :rules="[
            {
              required: true,
              type: 'number',
              message: '请选择折扣内容',
              trigger: 'change'
            }
          ]"
        >
          <RadioGroup
            v-model="formData.goodsType"
            type="button"
            @on-change="
              paymentOptions = []
              fetchGoods()
            "
            :disabled="readonly"
          >
            <Radio :disabled="readonly" :label="0">金币</Radio>
            <Radio :disabled="readonly" :label="1">订阅</Radio>
            <Radio :disabled="readonly" :label="2">通行证</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem
          label="付费项"
          prop="goodsId"
          :rules="[
            {
              required: true,
              message: '请选择付费项',
              trigger: 'change',
              validator(rule, value, cb) {
                if (!formData.goodsId) {
                  cb('请选择付费项')
                } else {
                  cb()
                }
              }
            }
          ]"
        >
          <Select
            v-model="formData.goodsId"
            placeholder="请选择付费项"
            :loading="goodsLoading"
            :disabled="readonly"
          >
            <Option
              v-for="(item, index) in paymentOptions"
              :key="index"
              :value="item.id"
            >
              {{ item.goodsName }} ({{ item.goodsPrice }})
            </Option>
          </Select>
        </FormItem>

        <FormItem label="弹窗预览">
          <div style="display: flex; gap: 20px; align-items: flex-start">
            <!-- 左侧：样式选择（仅订阅类型显示） -->
            <div v-if="formData.goodsType === 1" style="flex-shrink: 0">
              <div style="margin-bottom: 10px; font-weight: bold">
                选择样式：
              </div>
              <RadioGroup
                v-model="formData.discountStyle"
                vertical
                :disabled="readonly"
              >
                <Radio :label="1" :disabled="readonly">第一次折扣弹窗</Radio>
                <Radio :label="2" :disabled="readonly">第二次折扣弹窗</Radio>
                <Radio :label="3" :disabled="readonly">第三次折扣弹窗</Radio>
                <Radio :label="4" :disabled="readonly">第四次折扣弹窗</Radio>
                <Radio :label="5" :disabled="readonly">VIP折扣弹窗</Radio>
              </RadioGroup>
            </div>
            <!-- 右侧：预览图 -->
            <div class="preview-container">
              <img
                :src="discountPreviewImage"
                alt="预览图"
                class="preview-img"
                style="cursor: pointer"
                @click="$viewerApi({ images: [discountPreviewImage] })"
              />
            </div>
          </div>
        </FormItem>
      </template>

      <!-- 剧集推荐弹窗 (2) -->
      <template v-if="formData.type === 2">
        <FormItem
          label="弹窗样式"
          key="formDataType2"
          prop="popupStyle"
          :rules="[
            {
              required: true,
              type: 'number',
              message: '请选择弹窗样式',
              trigger: 'change'
            }
          ]"
        >
          <RadioGroup
            v-model="formData.popupStyle"
            type="button"
            @on-change="handleDramaStyleChange"
            :disabled="readonly"
          >
            <Radio :disabled="readonly" :label="1">居中弹窗</Radio>
            <Radio :disabled="readonly" :label="2">底部弹窗</Radio>
          </RadioGroup>
        </FormItem>

        <FormItem
          v-if="formData.popupStyle === 2"
          label="推荐剧目数量"
          prop="recommendCount"
          :rules="[
            {
              required: true,
              type: 'number',
              message: '请选择推荐数量',
              trigger: 'change'
            }
          ]"
        >
          <Select
            v-model="formData.recommendCount"
            @on-change="handleRecommendCountChange"
            :disabled="readonly"
          >
            <Option v-for="n in 5" :key="n" :value="n">{{ n }}部</Option>
          </Select>
        </FormItem>

        <div class="recommendation-item">
          <template v-if="formData.popupStyle === 2">
            <FormItem
              label="剧集内容"
              :prop="'recommendations[0].recommendType'"
            >
              <RadioGroup
                v-model="formData.recommendations[0].recommendType"
                type="button"
                :disabled="readonly"
                @on-change="handleRecommendTypeChangeOnRow(0, $event)"
              >
                <Radio :disabled="readonly" :label="1">系统推荐</Radio>
                <Radio :disabled="readonly" :label="2">指定剧目</Radio>
              </RadioGroup>
            </FormItem>
            <template v-if="formData.recommendations[0].recommendType === 1">
              <Button
                type="primary"
                style="margin-left: 120px"
                :disabled="readonly"
                @click="addItem"
                >+添加语言主推剧</Button
              >
              <div style="margin: 10px 120px; color: #999; font-weight: 600">
                手动配置的剧集推荐优先级高于系统推荐剧库中的剧集
              </div>
              <Card
                v-for="(card, cardIndex) in languageCards"
                :key="cardIndex"
                style="
                  margin-left: 120px;
                  margin-top: 10px;
                  width: 70%;
                  background-color: #f5f5f5;
                  position: relative;
                "
              >
                <Icon
                  v-if="!readonly"
                  type="ios-close"
                  @click="removeLanguageCard(cardIndex)"
                  style="
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    font-size: 22px;
                    cursor: pointer;
                    z-index: 10;
                    color: #999;
                    transition: color 0.2s ease;
                  "
                ></Icon>
                <FormItem
                  label="语言"
                  style="margin-left: -40px"
                  :rules="[
                    {
                      required: true,
                      message: '请选择语言',
                      trigger: 'change',
                      validator(rule, value, cb) {
                        if (!card.langId) {
                          cb('请选择语言')
                        } else {
                          cb()
                        }
                      }
                    }
                  ]"
                >
                  <Select
                    v-model="card.langId"
                    placeholder="请选择语言"
                    @on-change="handleLanguageChange(cardIndex, $event)"
                    :disabled="readonly"
                    style="width: 70%"
                  >
                    <Option
                      v-for="ln in languageList"
                      :key="ln.id"
                      :value="ln.id"
                      :disabled="
                        languageCards.some(
                          (item, idx) =>
                            idx !== cardIndex && item.langId === ln.id
                        )
                      "
                      >{{ ln.name }}
                    </Option>
                  </Select>
                </FormItem>
                <FormItem
                  v-for="(drama, dramaIndex) in card.dramas"
                  :key="dramaIndex"
                  :label="`剧目${dramaIndex + 1}`"
                  style="margin-left: -40px"
                >
                  <div style="display: flex; align-items: center">
                    <Select
                      v-model="drama.id"
                      filterable
                      clearable
                      :disabled="readonly || !card.langId"
                      placeholder="请输入剧集名称搜索"
                      style="width: 70%"
                      @on-change="
                        handleCardDramaChange(cardIndex, dramaIndex, $event)
                      "
                    >
                      <Option
                        v-for="d in getCardDramaOptions(card)"
                        :disabled="
                          card.dramas.some(
                            (currentDrama, currentIdx) =>
                              currentIdx !== dramaIndex &&
                              currentDrama.id === d.id
                          )
                        "
                        :key="d.id"
                        :value="d.id"
                        >{{ d.name }}</Option
                      >
                    </Select>
                    <Icon
                      v-if="!readonly && dramaIndex > 0"
                      type="ios-close-circle"
                      @click="removeDramaFromCard(cardIndex, dramaIndex)"
                      style="
                        margin-left: 8px;
                        cursor: pointer;
                        color: #ed4014;
                        font-size: 18px;
                        display: inline-block;
                        vertical-align: middle;
                      "
                    ></Icon>
                  </div>
                </FormItem>
                <span
                  v-if="!readonly"
                  style="
                    margin-left: 100px;
                    color: cornflowerblue;
                    font-weight: 600;
                    cursor: pointer;
                    display: inline-block;
                  "
                  @click="addDramaToCard(cardIndex)"
                >
                  +添加剧目
                </span>
              </Card>
            </template>
            <template v-else>
              <div
                v-for="(item, index) in formData.recommendations"
                :key="index"
              >
                <FormItem
                  :label="`剧目 ${index + 1}`"
                  :prop="'recommendations[' + index + '].parentPlayId'"
                  :rules="[
                    {
                      required: true,
                      message: '请选择剧目',
                      trigger: 'change',
                      validator(rule, value, cb) {
                        if (!formData.recommendations[index].parentPlayId) {
                          cb('请选择剧目')
                        } else {
                          cb()
                        }
                      }
                    }
                  ]"
                >
                  <Select
                    v-model="formData.recommendations[index].parentPlayId"
                    filterable
                    clearable
                    :loading="searchLoading"
                    placeholder="请输入剧目名称并搜索"
                    :disabled="readonly"
                    @on-query-change="searchDramas"
                  >
                    <Option
                      v-for="d in getAvailableDramaOptions(index)"
                      :disabled="!!isRecommendationDramaDisabled(d.id, index)"
                      :key="d.id"
                      :value="d.id"
                      >{{ d.name }}</Option
                    >
                  </Select>
                </FormItem>
              </div>
            </template>
          </template>
          <template v-else>
            <div v-for="(item, index) in formData.recommendations" :key="index">
              <FormItem
                label="剧集内容"
                :prop="'recommendations[' + index + '].recommendType'"
              >
                <RadioGroup
                  v-model="formData.recommendations[index].recommendType"
                  type="button"
                  :disabled="readonly"
                  @on-change="handleRecommendTypeChangeOnRow(index, $event)"
                >
                  <Radio :disabled="readonly" :label="1">系统推荐</Radio>
                  <Radio :disabled="readonly" :label="2">指定剧目</Radio>
                </RadioGroup>
              </FormItem>
              <template v-if="item.recommendType === 1">
                <Button
                  type="primary"
                  style="margin-left: 120px"
                  @click="addItem"
                  :disabled="readonly"
                  >+添加语言主推剧</Button
                >
                <div style="margin: 10px 120px; color: #999; font-weight: 600">
                  手动配置的剧集推荐优先级高于系统推荐剧库中的剧集
                </div>
                <Card
                  v-for="(card, cardIndex) in languageCards"
                  :key="cardIndex"
                  style="
                    margin-left: 120px;
                    margin-top: 10px;
                    width: 70%;
                    background-color: #f5f5f5;
                    position: relative;
                "
              >
                <Icon
                  v-if="!readonly"
                  type="ios-close"
                  @click="removeLanguageCard(cardIndex)"
                  style="
                    position: absolute;
                      top: 10px;
                      right: 10px;
                      font-size: 22px;
                      cursor: pointer;
                      z-index: 10;
                      color: #999;
                      transition: color 0.2s ease;
                    "
                  ></Icon>
                  <FormItem label="语言" style="margin-left: -40px">
                    <Select
                      v-model="card.langId"
                      placeholder="请选择语言"
                      @on-change="handleLanguageChange(cardIndex, $event)"
                      :disabled="readonly"
                      style="width: 70%"
                    >
                      <Option
                        v-for="ln in languageList"
                        :key="ln.id"
                        :value="ln.id"
                        :disabled="
                          languageCards.some(
                            (item, idx) =>
                              idx !== cardIndex && item.langId === ln.id
                          )
                        "
                        >{{ ln.name }}
                      </Option>
                    </Select>
                  </FormItem>
                  <FormItem
                    v-for="(drama, dramaIndex) in card.dramas"
                    :key="dramaIndex"
                    :label="`剧目${dramaIndex + 1}`"
                    style="margin-left: -40px"
                  >
                    <div style="display: flex; align-items: center">
                      <Select
                        v-model="drama.id"
                        filterable
                        clearable
                        :disabled="readonly || !card.langId"
                        placeholder="请输入剧集名称搜索"
                        style="width: 70%"
                        @on-change="
                          handleCardDramaChange(cardIndex, dramaIndex, $event)
                        "
                      >
                        <Option
                          v-for="d in getCardDramaOptions(card)"
                          :disabled="
                            card.dramas.some(
                              (currentDrama, currentIdx) =>
                                currentIdx !== dramaIndex &&
                                currentDrama.id === d.id
                            )
                          "
                          :key="d.id"
                          :value="d.id"
                          >{{ d.name }}</Option
                      >
                    </Select>
                    <Icon
                      v-if="!readonly && dramaIndex > 0"
                      type="ios-close-circle"
                      @click="removeDramaFromCard(cardIndex, dramaIndex)"
                      style="
                        margin-left: 8px;
                          cursor: pointer;
                          color: #ed4014;
                          font-size: 18px;
                          display: inline-block;
                          vertical-align: middle;
                        "
                      ></Icon>
                    </div>
                  </FormItem>
                  <span
                    v-if="!readonly"
                    style="
                      margin-left: 100px;
                      color: cornflowerblue;
                      font-weight: 600;
                      cursor: pointer;
                      display: inline-block;
                    "
                    @click="addDramaToCard(cardIndex)"
                  >
                    +添加剧目
                  </span>
                </Card>
              </template>
              <template v-if="item.recommendType === 2">
                <FormItem
                  label="剧目"
                  :prop="'recommendations[' + index + '].parentPlayId'"
                  :rules="[
                    {
                      required: true,
                      message: '请选择剧目',
                      trigger: 'change',
                      validator(rule, value, cb) {
                        if (!formData.recommendations[index].parentPlayId) {
                          cb('请选择剧目')
                        } else {
                          cb()
                        }
                      }
                    }
                  ]"
                >
                  <Select
                    v-model="formData.recommendations[index].parentPlayId"
                    filterable
                    clearable
                    :loading="searchLoading"
                    placeholder="请输入剧目名称并搜索"
                    :disabled="readonly"
                    @on-query-change="searchDramas"
                  >
                    <Option
                      v-for="d in getAvailableDramaOptions(index)"
                      :disabled="isRecommendationDramaDisabled(d.id, index)"
                      :key="d.id"
                      :value="d.id"
                      >{{ d.name }}</Option
                    >
                  </Select>
                </FormItem>
              </template>
            </div>
          </template>
        </div>

        <FormItem label="弹窗预览">
          <div class="preview-container">
            <img
              :src="dramaPreviewImage"
              alt="预览图"
              class="preview-img"
              style="cursor: pointer"
              @click="$viewerApi({ images: [dramaPreviewImage] })"
            />
          </div>
        </FormItem>
      </template>

      <!-- 登录弹窗 (3) -->
      <template v-if="formData.type === 3">
        <FormItem label="弹窗预览">
          <div class="preview-container">
            <img
              :src="loginPopupImg"
              alt="登录预览"
              class="preview-img"
              style="cursor: pointer"
              @click="$viewerApi({ images: [loginPopupImg] })"
            />
            <div style="margin-top: 10px; color: #999">
              使用 App 标准登录界面
            </div>
          </div>
        </FormItem>
      </template>

      <!-- 观看激励视频弹窗 (4) -->
      <template v-if="formData.type === 4">
        <FormItem
          label="奖励内容"
          prop="rewardType"
          :rules="[
            {
              required: true,
              type: 'number',
              message: '请选择奖励内容',
              trigger: 'change'
            }
          ]"
        >
          <Select
            v-model="formData.rewardType"
            placeholder="请选择奖励内容"
            :disabled="readonly"
            @on-change="handleRewardTypeChange"
          >
            <Option :value="1">赠币</Option>
            <Option :value="2">解锁短剧</Option>
          </Select>
        </FormItem>
        <!-- Bonus Coins UI (Type 1) -->
        <template v-if="formData.rewardType === 1">
          <FormItem
            label="赠币数量"
            prop="coinAmount"
            :rules="[
              {
                required: true,
                type: 'number',
                message: '请输入大于0的金额',
                trigger: 'blur'
              }
            ]"
          >
            <InputNumber
              v-model="formData.coinAmount"
              :min="1"
              :max="10000"
              :precision="0"
              style="width: 100%"
              :disabled="readonly"
            />
          </FormItem>
          <FormItem
            label="弹窗尺寸"
            prop="popupSize"
            :rules="[
              {
                required: true,
                type: 'number',
                message: '请选择尺寸',
                trigger: 'change'
              }
            ]"
          >
            <RadioGroup
              v-model="formData.popupSize"
              type="button"
              :disabled="readonly"
              @on-change="
                formData.popupFileUrl = ''
                formData.buttonFileUrl = ''
                formData.popupFileId = ''
                formData.buttonFileId = ''
              "
            >
              <Radio :disabled="readonly" :label="1">大图 (600*800)</Radio>
              <Radio :disabled="readonly" :label="2">小图 (480*640)</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="弹窗标题" prop="popupTitle">
            <Input
              v-model="formData.popupTitle"
              placeholder="请输入标题 (可选)"
              :disabled="readonly"
            />
          </FormItem>
          <FormItem
            label="上传图片"
            prop="popupFileUrl"
            :rules="[
              { required: true, message: '请上传图片', trigger: 'change' }
            ]"
          >
            <PopupUpload
              v-model="formData.popupFileUrl"
              title="点击上传 弹窗图片"
              :hint="
                '仅支持 ' +
                (formData.popupSize === 1 ? '600*800' : '480*640') +
                ' 尺寸, jpg/png 格式, <2mb大小'
              "
              :exact-width="formData.popupSize === 1 ? 600 : 480"
              :exact-height="formData.popupSize === 1 ? 800 : 640"
              @on-success="(data) => (formData.popupFileId = data.fileId)"
              :disabled="readonly"
            />
          </FormItem>

          <FormItem
            label="按钮图片"
            prop="buttonFileUrl"
            :rules="[
              { required: true, message: '请上传按钮图片', trigger: 'change' }
            ]"
          >
            <PopupUpload
              v-model="formData.buttonFileUrl"
              title="点击上传 按钮图片"
              mode="button"
              :hint="
                '仅支持 ' +
                (formData.popupSize === 1 ? '520*98' : '420*98') +
                ' 尺寸, jpg/png 格式'
              "
              :exact-width="formData.popupSize === 1 ? 520 : 420"
              :exact-height="98"
              @on-success="(data) => (formData.buttonFileId = data.fileId)"
              :disabled="readonly"
            />
          </FormItem>
          <FormItem
            v-if="formData.type === 4"
            label="弹窗按钮文案"
            prop="buttonText"
            :rules="[
              { required: true, message: '请输入按钮文案', trigger: 'blur' }
            ]"
          >
            <Input
              v-model="formData.buttonText"
              placeholder="例如: 立即前往"
              :disabled="readonly"
            />
          </FormItem>

          <FormItem label="弹窗预览">
            <!-- Composite Preview -->
            <div
              class="incentive-preview-wrapper"
              :style="{
                width: '200px',
                height: formData.popupSize === 1 ? '266px' : '266px',
                cursor: 'pointer'
              }"
              @click="previewCompositePopup"
            >
              <!-- Background Popup Image -->
              <img
                v-if="formData.popupFileUrl"
                :src="formData.popupFileUrl"
                class="preview-bg"
              />
              <div v-else class="preview-placeholder">暂无背景图</div>

              <!-- Button Image (Stacked Bottom) -->
              <div
                class="preview-btn-overlay"
                :style="{ width: formData.popupSize === 1 ? '86.6%' : '87.5%' }"
              >
                <img
                  v-if="formData.buttonFileUrl"
                  :src="formData.buttonFileUrl"
                  class="preview-btn-img"
                />
              </div>
            </div>
            <div style="color: #999; font-size: 12px; margin-top: 5px">
              预览仅供参考，实际效果以客户端渲染为准<br />
              大图: 600*800 (按钮宽520)<br />
              小图: 480*640 (按钮宽420*98)
            </div>
          </FormItem>
        </template>
        <template v-if="formData.rewardType === 2">
          <FormItem
            label="今日可解锁"
            prop="dailyLimit"
          >
            <InputNumber
              v-model="formData.dailyLimit"
              :min="1"
              :max="99"
              :precision="0"
              style="width: 100px"
              :disabled="readonly"
            />
            次
          </FormItem>
          <div style="margin-left: 110px; margin-bottom: 24px">
            看
            <InputNumber
              v-model="formData.adsRequired"
              :min="1"
              :max="20"
              :precision="0"
              style="width: 80px"
              :disabled="readonly"
            />
            个广告解锁
            <InputNumber
              v-model="formData.episodesUnlocked"
              :min="1"
              :max="20"
              :precision="0"
              style="width: 80px"
              :disabled="readonly"
            />
            集
          </div>
          <FormItem label="弹窗预览">
            <div class="preview-container">
              <img
                :src="dramaPreviewImage"
                alt="预览图"
                class="preview-img"
                style="cursor: pointer"
                @click="$viewerApi({ images: [dramaPreviewImage] })"
              />
            </div>
          </FormItem>
        </template>
      </template>

      <!-- 自定义弹窗 (5) -->
      <template v-if="formData.type === 5">
        <FormItem
          label="跳转页面"
          prop="activityConfigId"
          :rules="[
            {
              required: true,
              type: 'number',
              message: '请选择跳转页面',
              trigger: 'change'
            }
          ]"
        >
          <Select
            v-model="formData.activityConfigId"
            placeholder="请选择跳转页面"
            :disabled="readonly"
            @on-change="handleJumpTypeChange"
          >
            <Option
              v-for="(item, index) in jumpTypeLi"
              :key="index"
              :value="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <FormItem
          label="弹窗尺寸"
          prop="popupSize"
          :rules="[
            {
              required: true,
              type: 'number',
              message: '请选择尺寸',
              trigger: 'change'
            }
          ]"
        >
          <RadioGroup
            v-model="formData.popupSize"
            type="button"
            :disabled="readonly"
            @on-change="
              formData.popupFileUrl = ''
              formData.buttonFileUrl = ''
              formData.popupFileId = ''
              formData.buttonFileId = ''
            "
          >
            <Radio :disabled="readonly" :label="1">大图 (600*800)</Radio>
            <Radio :disabled="readonly" :label="2">小图 (480*640)</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem
          label="弹窗背景图"
          prop="popupFileUrl"
          :rules="[
            { required: true, message: '请上传图片', trigger: 'change' }
          ]"
        >
          <PopupUpload
            v-model="formData.popupFileUrl"
            title="点击上传 弹窗图片"
            :hint="
              '仅支持 ' +
              (formData.popupSize === 1 ? '600*800' : '480*640') +
              ' 尺寸, jpg/png 格式, <2mb大小'
            "
            :exact-width="formData.popupSize === 1 ? 600 : 480"
            :exact-height="formData.popupSize === 1 ? 800 : 640"
            @on-success="(data) => (formData.popupFileId = data.fileId)"
            :disabled="readonly"
          />
        </FormItem>
        <FormItem
          label="按钮图片"
          prop="buttonFileUrl"
          :rules="[
            { required: true, message: '请上传按钮图片', trigger: 'change' }
          ]"
        >
          <PopupUpload
            v-model="formData.buttonFileUrl"
            mode="button"
            title="点击上传 按钮图片"
            :hint="
              '仅支持 ' +
              (formData.popupSize === 1 ? '520*98' : '420*98') +
              ' 尺寸, jpg/png 格式'
            "
            :exact-width="formData.popupSize === 1 ? 520 : 420"
            :exact-height="98"
            @on-success="(data) => (formData.buttonFileId = data.fileId)"
            :disabled="readonly"
          />
        </FormItem>
        <FormItem
          label="按钮文案"
          prop="buttonText"
          :rules="[
            { required: true, message: '请输入按钮文案', trigger: 'blur' }
          ]"
        >
          <Input
            v-model="formData.buttonText"
            placeholder="请输入按钮文案 (可选)"
            :disabled="readonly"
          />
        </FormItem>

        <FormItem label="弹窗预览">
          <!-- Composite Preview -->
          <div
            class="incentive-preview-wrapper"
            :style="{
              width: '200px',
              height: formData.popupSize === 1 ? '266px' : '266px',
              cursor: 'pointer'
            }"
            @click="previewCompositePopup"
          >
            <!-- Background Popup Image -->
            <img
              v-if="formData.popupFileUrl"
              :src="formData.popupFileUrl"
              class="preview-bg"
            />
            <div v-else class="preview-placeholder">暂无背景图</div>

            <!-- Button Image (Stacked Bottom) -->
            <div
              class="preview-btn-overlay"
              :style="{ width: formData.popupSize === 1 ? '86.6%' : '87.5%' }"
            >
              <img
                v-if="formData.buttonFileUrl"
                :src="formData.buttonFileUrl"
                class="preview-btn-img"
              />
            </div>
          </div>
          <div style="color: #999; font-size: 12px; margin-top: 5px">
            预览仅供参考，实际效果以客户端渲染为准<br />
            大图: 600*800 (按钮宽520)<br />
            小图: 480*640 (按钮宽420*98)
          </div>
        </FormItem>
        <FormItem label="关闭按钮设置" prop="allowClose">
          <RadioGroup
            v-model="formData.allowClose"
            type="button"
            :disabled="readonly"
          >
            <Radio :disabled="readonly" :label="1">允许关闭</Radio>
            <Radio :disabled="readonly" :label="0">不允许关闭</Radio>
          </RadioGroup>
        </FormItem>
      </template>

      <!-- 通知弹窗 (6) -->
      <template v-if="formData.type === 6">
        <FormItem label="弹窗预览">
          <div class="preview-container">
            <img
              :src="noticePopupImg"
              alt="通知预览"
              class="preview-img"
              style="cursor: pointer"
              @click="$viewerApi({ images: [noticePopupImg] })"
            />
          </div>
        </FormItem>
      </template>

      <FormItem
        label="弹窗备注名称"
        prop="popupName"
        :rules="[
          { required: true, message: '请输入弹窗备注名称', trigger: 'blur' }
        ]"
      >
        <Input
          v-model="formData.popupName"
          placeholder="请输入弹窗备注 (仅后台展示)"
          :disabled="readonly"
        />
      </FormItem>
    </Form>
    <template #footer v-if="!readonly">
      <Button @click="handleCancel">取消</Button>
      <Button type="primary" :loading="loading" @click="handleSubmit"
        >保存</Button
      >
    </template>
  </Modal>
</template>

<script>
import PopupUpload from '@/components/Upload/PopupUpload.vue'
import { addPopup, editPopup, getJumpOptions } from '@/api/popup'
import { getGoodsList } from '@/api/goods'
import { getDictionaryList } from '@/api/dictionary'
import { getPrimaryList as getPlayList } from '@/api/play'
import { getSeriesList } from '@/api/series'
import { getLangList } from '@/api/lang'
import discountPopupImg from '@/assets/images/discount_popup.png'
import discountPopupImgCoin from '@/assets/images/discount_popup_coin.png'
import discountStyle1Img from '@/assets/images/1.png'
import discountStyle2Img from '@/assets/images/2.png'
import discountStyle3Img from '@/assets/images/3.png'
import discountStyle4Img from '@/assets/images/4.png'
import discountStyle5Img from '@/assets/images/5.png'
import dramaPopupCenterImg from '@/assets/images/drama_popup_center.png'
import dramaPopupBottomImg from '@/assets/images/drama_popup_bottom.png'
import paypalImg from '@/assets/images/paypal.png'
import loginPopupImg from '@/assets/images/login_popup.jpg'
import noticePopupImg from '@/assets/images/notice_popup.png'
import unlockImage from '@/assets/images/unlock.png'
import { debounce } from 'lodash'
import { InputNumber } from 'view-design'

export default {
  name: 'EditModal',
  components: {
    PopupUpload
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      unlockImage,
      searchLoading: false,
      goodsLoading: false,
      paymentOptions: [],
      loginPopupImg,
      noticePopupImg,
      formData: {
        popupName: '',
        popupType: 1, // API uses popupType
        type: 1, // UI binding
        deviceSys: 0,
        goodsType: 0,
        goodsId: '',
        popupStyle: 1, // API uses popupStyle
        recommendCount: 1,
        recommendations: [{ recommendType: 1, parentPlayId: '' }],
        rewardType: 1,
        coinAmount: 0,
        adsRequired: 1,
        episodesUnlocked: 1,
        dailyLimit: 1,
        popupSize: 1,
        popupTitle: '',
        popupFileUrl: '',
        popupFileId: '',
        buttonFileUrl: '',
        buttonFileId: '',
        buttonText: '',
        jumpPage: '',
        jumpType: '',
        activityConfigId: '',
        allowClose: 1,
        discountStyle: 1 // 折扣弹窗样式：1-5，仅订阅类型有效
      },
      jumpTypeLi: [],
      dramaOptions: [],
      languageList: [],
      selectList: [],
      languageCards: []
    }
  },
  // mounted(){
  //   this.fetchGoods()
  // },
  computed: {
    modalTitle() {
      if (this.readonly) return '查看弹窗'
      return (this.formData.id ? '编辑' : '新增') + '弹窗'
    },
    previewImage() {
      // Logic from requirements:
      // Since the doc image is generic "Discount Popup", we just return that for now.
      // If specific images for coin vs sub exist, we would switch here.
      // For now, using the captured discount popup image.
      if (this.formData.goodsType == 0) return discountPopupImgCoin
      return discountPopupImg
    },
    dramaPreviewImage() {
      if (this.formData.popupStyle === 1 || this.formData.type === 4) {
        // POPUP_STYLE: 1 Center
        return dramaPopupCenterImg
      }
      return dramaPopupBottomImg
    },
    activeDramaRecommendType() {
      const firstItem =
        Array.isArray(this.formData.recommendations) &&
        this.formData.recommendations.length
          ? this.formData.recommendations[0]
          : null
      return firstItem && firstItem.recommendType ? firstItem.recommendType : 1
    },
    discountPreviewImage() {
      // 金币类型使用金币折扣图
      if (this.formData.goodsType === 0) {
        return discountPopupImgCoin
      }
      if (this.formData.goodsType === 2) {
        return paypalImg
      }
      // 订阅类型根据 discountStyle 返回对应预览图
      const styleImages = {
        1: discountStyle1Img,
        2: discountStyle2Img,
        3: discountStyle3Img,
        4: discountStyle4Img,
        5: discountStyle5Img
      }
      return styleImages[this.formData.discountStyle] || discountStyle1Img
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.visible = val
        if (val) {
          if (this.data.id) {
            this.mapDataToForm(this.data)
          } else {
            this.resetFormData()
          }
        }
      }
    },
    visible(val) {
      this.$emit('input', val)
      if (this.visible) {
        if (this.formData.type === 1) {
          this.fetchGoods()
        }
        if (this.formData.type === 2) {
          this.searchDramas()
          this.getLang()
          this.loadLanguageCardOptions()
        }
        if (this.formData.type === 5) {
          this.handleGetJumpType()
        }
      }
    }
  },
  methods: {
    async handleGetJumpType() {
      await getJumpOptions().then((r) => {
        this.jumpTypeLi = r.data
        console.log(this.jumpTypeLi)
      })
    },
    handleJumpTypeChange(selectedId) {
    const selectedItem = this.jumpTypeLi.find(item => item.id === selectedId)
    if (selectedItem) {
      this.formData.jumpType = selectedItem.jumpType
    } else {
      this.formData.jumpType = ''
    }
  },
    createEmptyDrama() {
      return {
        id: '',
        name: '',
        createTime: ''
      }
    },
    createDramaRecommendation(recommendType, source = {}) {
      return {
        recommendType: recommendType || 1,
        parentPlayId:
          source.parentPlayId !== undefined && source.parentPlayId !== null
            ? source.parentPlayId
            : '',
        parentPlayName: source.parentPlayName || '',
        playPromotionCoverId:
          source.playPromotionCoverId !== undefined &&
          source.playPromotionCoverId !== null
            ? source.playPromotionCoverId
            : '',
        playPromotionCoverTitle: source.playPromotionCoverTitle || ''
      }
    },
    createLanguageCard(source = {}) {
      const dramas =
        Array.isArray(source.dramas) && source.dramas.length
          ? source.dramas.map((item) => ({
              id:
                item.id !== undefined && item.id !== null
                  ? item.id
                  : item.parentPlayId || '',
              name: item.name || item.parentPlayName || '',
              createTime: item.createTime || ''
            }))
          : [this.createEmptyDrama()]

      return {
        langId: source.langId || '',
        langName: source.langName || '',
        dramas,
        dramaOptions: this.mergeDramaOptions([], dramas),
        loading: false
      }
    },
    isPlaceholderDramaName(name) {
      return typeof name === 'string' && /^剧目\s*\d+$/.test(name.trim())
    },
    mergeDramaOptions(existing = [], incoming = []) {
      const optionMap = new Map()
      ;[...existing, ...incoming].forEach((item) => {
        if (!item) return
        const id =
          item.id !== undefined && item.id !== null
            ? item.id
            : item.parentPlayId
        if (id === '' || id === undefined || id === null) return
        const current = optionMap.get(String(id))
        const candidateNames = [
          item.name,
          item.parentPlayName,
          current && current.name
        ].filter(Boolean)
        const nextName =
          candidateNames.find((name) => !this.isPlaceholderDramaName(name)) ||
          candidateNames[0] ||
          ''
        optionMap.set(String(id), {
          id,
          name: nextName
        })
      })
      return Array.from(optionMap.values())
    },
    getCurrentTimeString() {
      const date = new Date()
      const pad = (value) => String(value).padStart(2, '0')
      return (
        [
          date.getFullYear(),
          pad(date.getMonth() + 1),
          pad(date.getDate())
        ].join('-') +
        ' ' +
        [
          pad(date.getHours()),
          pad(date.getMinutes()),
          pad(date.getSeconds())
        ].join(':')
      )
    },
    getRecommendTypeFromDetail(data) {
      if (data.recommendType) return data.recommendType
      if (
        Array.isArray(data.playContent) &&
        data.playContent.length &&
        data.playContent[0].recommendType
      ) {
        return data.playContent[0].recommendType
      }
      return 1
    },
    buildRecommendationsFromDetail(data) {
      const popupStyle = Number(data.popupStyle || 1)
      const recommendType = this.getRecommendTypeFromDetail(data)
      const recommendCount =
        popupStyle === 1
          ? 1
          : Number(
              data.recommendCount ||
                (Array.isArray(data.playContent)
                  ? data.playContent.length
                  : 0) ||
                1
            )

      if (popupStyle === 1) {
        const source =
          recommendType === 2
            ? {
                parentPlayId: data.parentPlayId,
                parentPlayName: data.parentPlayName,
                playPromotionCoverId: data.playPromotionCoverId,
                playPromotionCoverTitle: data.playPromotionCoverTitle
              }
            : {}
        return [this.createDramaRecommendation(recommendType, source)]
      }

      const playContent = Array.isArray(data.playContent)
        ? data.playContent
        : []
      return Array.from({ length: recommendCount }, (_, index) => {
        const source = recommendType === 2 ? playContent[index] || {} : {}
        return this.createDramaRecommendation(recommendType, source)
      })
    },
    normalizeLanguageCards(recommendPlayContent = []) {
      return (recommendPlayContent || []).map((item) =>
        this.createLanguageCard({
          langId: item.langId,
          langName: item.langName,
          dramas: (item.parentPlayIds || []).map((drama) => ({
            id: drama.parentPlayId,
            name: drama.parentPlayName,
            createTime: drama.createTime
          }))
        })
      )
    },
    loadLanguageCardOptions() {
      this.languageCards.forEach((card, index) => {
        if (card.langId) {
          this.getLangDramas(card, index)
        }
      })
    },
    async getLang() {
      const { data } = await getLangList({current:1,size: 100,langStatus:true})
      if (data && data.records) {
        this.languageList = data.records.map((item) => ({
          id: item.id,
          name: item.chineseLangName
        }))
      }
    },
    async getLangDramas(card, cardIndex, query = '') {
      if (!card.langId) return
      this.$set(this.languageCards[cardIndex], 'loading', true)
      try {
        const allOptions = []
        let current = 1
        const size = 500
        let totalPages = 1
        do {
          const { data } = await getPlayList({
            current,
            size,
            originalLangId: card.langId,
            keyword: query
          })
          const records = data.records || []
          allOptions.push(...records.map((item) => ({
            id: item.id,
            name: item.playName
          })))
          totalPages = data.pages || Math.ceil((data.total || 0) / size)
          current++
        } while (current <= totalPages)
        this.$set(
          this.languageCards[cardIndex],
          'dramaOptions',
          this.mergeDramaOptions(
            this.languageCards[cardIndex].dramaOptions || [],
            [...allOptions, ...(this.languageCards[cardIndex].dramas || [])]
          )
        )
      } catch (error) {
        this.$Message.error('获取语言剧目失败')
      } finally {
        this.$set(this.languageCards[cardIndex], 'loading', false)
      }
    },
    handleLanguageChange(cardIndex, langId) {
      const lang = this.languageList.find((item) => item.id === langId) || {}
      this.$set(
        this.languageCards,
        cardIndex,
        this.createLanguageCard({
          langId,
          langName: lang.name || ''
        })
      )
      this.getLangDramas(this.languageCards[cardIndex], cardIndex)
    },
    findDramaOptionById(options = [], dramaId) {
      if (dramaId === '' || dramaId === undefined || dramaId === null) return null
      return options.find((item) => String(item.id) === String(dramaId)) || null
    },
    handleCardDramaChange(cardIndex, dramaIndex, selectedId) {
      const card = this.languageCards[cardIndex]
      if (!card || !Array.isArray(card.dramas) || !card.dramas[dramaIndex]) return

      if (selectedId === '' || selectedId === undefined || selectedId === null) {
        this.$set(card.dramas, dramaIndex, this.createEmptyDrama())
        return
      }

      const options = this.getCardDramaOptions(card)
      const selectedDrama = this.findDramaOptionById(options, selectedId)
      const currentDrama = card.dramas[dramaIndex] || this.createEmptyDrama()

      this.$set(card.dramas, dramaIndex, {
        ...currentDrama,
        id: selectedId,
        name: selectedDrama ? selectedDrama.name : '',
        createTime: ''
      })
    },
    getCardDramaOptions(card) {
      return this.mergeDramaOptions(card.dramas || [], card.dramaOptions || [])
    },
    getAvailableDramaOptions(index) {
      return this.dramaOptions
    },
    isRecommendationDramaDisabled(dramaId, index) {
      if (dramaId === '' || dramaId === undefined || dramaId === null) return false
      const currentId =
        this.formData.recommendations &&
        this.formData.recommendations[index] &&
        this.formData.recommendations[index].parentPlayId
      if (
        currentId !== '' &&
        currentId !== undefined &&
        currentId !== null &&
        String(currentId) === String(dramaId)
      ) {
        return false
      }
      return (this.formData.recommendations || []).some(
        (recommendation, recommendationIndex) =>
          recommendationIndex !== index &&
          recommendation.parentPlayId !== '' &&
          recommendation.parentPlayId !== undefined &&
          recommendation.parentPlayId !== null &&
          String(recommendation.parentPlayId) === String(dramaId)
      )
    },
    mapDataToForm(data) {
      const popupType = Number(data.popupType || data.type || 1)
      const popupStyle = Number(data.popupStyle || 1)
      const recommendations = this.buildRecommendationsFromDetail(data)
      const recommendCount =
        popupStyle === 1
          ? 1
          : Number(
              data.recommendCount ||
                (Array.isArray(data.playContent)
                  ? data.playContent.length
                  : 0) ||
                1
            )

      const newFormData = {
        id: data.id,
        popupName: data.popupName,
        type: popupType,
        popupType,
        deviceSys:
          data.deviceSys === 0 || data.deviceSys === 1 || data.deviceSys === -1
            ? data.deviceSys
            : 0,
        goodsType:
          data.goodsType === 0 || data.goodsType === 1 || data.goodsType === 2 ? data.goodsType : 0,
        goodsId: data.goodsId,
        popupStyle,
        recommendCount,
        recommendations,
        rewardType: data.rewardType || 1,
        coinAmount: data.coinAmount || 0,
        adsRequired: data.adsRequired || 1,
        episodesUnlocked: data.episodesUnlocked || 1,
        dailyLimit: data.dailyLimit || 1,
        popupSize: data.popupSize || 1,
        popupTitle: data.popupTitle,
        popupFileUrl: data.popupFileUrl,
        popupFileId: data.popupFileId,
        buttonFileUrl: data.buttonFileUrl,
        buttonFileId: data.buttonFileId,
        buttonText: data.buttonText,
        jumpPage: data.jumpPage,
        jumpType: data.jumpType,
        activityConfigId: data.activityConfigId,
        allowClose: data.allowClose === 0 ? 0 : 1,
        discountStyle: data.discountStyle || 1
      }
      this.formData = newFormData
      this.languageCards = this.normalizeLanguageCards(
        data.recommendPlayContent
      )
      this.dramaOptions = this.mergeDramaOptions(
        this.dramaOptions,
        recommendations
      )
    },
    resetFormData() {
      this.formData = {
        id: '',
        popupName: '',
        type: 1,
        popupType: 1,
        deviceSys: 0,
        goodsType: 0,
        goodsId: '',
        popupStyle: 1,
        recommendCount: 1,
        recommendations: [this.createDramaRecommendation(1)],
        rewardType: 1,
        coinAmount: 0,
        adsRequired: 1,
        episodesUnlocked: 1,
        dailyLimit: 1,
        popupSize: 1,
        popupTitle: '',
        popupFileUrl: '',
        popupFileId: '',
        buttonFileUrl: '',
        buttonFileId: '',
        buttonText: '',
        jumpPage: '',
        jumpType: '',
        activityConfigId: '',
        allowClose: 1,
        discountStyle: 1
      }
      this.languageCards = []
    },
    handleTypeChange(val) {
      this.formData.popupType = val

      const baseFields = {
        id: '',
        popupName: '',
        type: val,
        popupType: val
      }

      let typeSpecificFields = {}

      if (val === 1) {
        typeSpecificFields = {
          deviceSys: 0,
          goodsType: 0,
          goodsId: '',
          discountStyle: 1,
          popupStyle: null,
          recommendCount: null,
          recommendations: null,
          rewardType: null,
          coinAmount: null,
          adsRequired: null,
          episodesUnlocked: null,
          dailyLimit: null,
          popupSize: null,
          popupTitle: null,
          popupFileUrl: null,
          popupFileId: null,
          buttonFileUrl: null,
          buttonFileId: null,
          buttonText: null,
          jumpPage: null,
          jumpType: null,
          allowClose: null
        }
      } else if (val === 2) {
        typeSpecificFields = {
          popupStyle: 1,
          recommendCount: 1,
          recommendations: [this.createDramaRecommendation(1)],
          deviceSys: null,
          goodsType: null,
          goodsId: null,
          rewardType: null,
          coinAmount: null,
          adsRequired: null,
          episodesUnlocked: null,
          dailyLimit: null,
          popupSize: null,
          popupTitle: null,
          popupFileUrl: null,
          popupFileId: null,
          buttonFileUrl: null,
          buttonFileId: null,
          buttonText: null,
          jumpPage: null,
          jumpType: null,
          allowClose: null,
          discountStyle: null
        }
      } else if (val === 3) {
        typeSpecificFields = {
          deviceSys: null,
          goodsType: null,
          goodsId: null,
          popupStyle: null,
          recommendCount: null,
          recommendations: null,
          rewardType: null,
          coinAmount: null,
          adsRequired: null,
          episodesUnlocked: null,
          dailyLimit: null,
          popupSize: null,
          popupTitle: null,
          popupFileUrl: null,
          popupFileId: null,
          buttonFileUrl: null,
          buttonFileId: null,
          buttonText: null,
          jumpPage: null,
          jumpType: null,
          allowClose: null,
          discountStyle: null
        }
      } else if (val === 4) {
        typeSpecificFields = {
          rewardType: 1,
          coinAmount: 0,
          adsRequired: 1,
          episodesUnlocked: 1,
          dailyLimit: 1,
          popupSize: 1,
          popupTitle: '',
          popupFileUrl: '',
          popupFileId: '',
          buttonFileUrl: '',
          buttonFileId: '',
          buttonText: '',
          deviceSys: null,
          goodsType: null,
          goodsId: null,
          popupStyle: null,
          recommendCount: null,
          recommendations: null,
          jumpPage: null,
          jumpType: null,
          allowClose: null,
          discountStyle: null
        }
      } else if (val === 5) {
        typeSpecificFields = {
          jumpType: this.formData.jumpType || '',
          activityConfigId: this.formData.activityConfigId || '',
          popupSize: 1,
          popupFileUrl: '',
          popupFileId: '',
          buttonFileUrl: '',
          buttonFileId: '',
          buttonText: '',
          allowClose: 1,
          jumpPage: '',
          deviceSys: null,
          goodsType: null,
          goodsId: null,
          popupStyle: null,
          recommendCount: null,
          recommendations: null,
          rewardType: null,
          coinAmount: null,
          adsRequired: null,
          episodesUnlocked: null,
          dailyLimit: null,
          popupTitle: null,
          discountStyle: null
        }
      }

      this.formData = {
        ...baseFields,
        ...typeSpecificFields
      }
      this.languageCards = []
      if (val === 1) {
        this.fetchGoods()
      }
      if (val === 2) {
        this.searchDramas()
        this.getLang()
      }
      if (val === 5) {
        this.handleGetJumpType()
      }
    },
    handleRewardTypeChange(val) {
      if (val === 1) {
        if (!this.formData.coinAmount || this.formData.coinAmount < 1) {
          this.$set(this.formData, 'coinAmount', 1)
        }
        return
      }

      if (val === 2) {
        this.$set(
          this.formData,
          'adsRequired',
          this.formData.adsRequired && this.formData.adsRequired > 0
            ? this.formData.adsRequired
            : 1
        )
        this.$set(
          this.formData,
          'episodesUnlocked',
          this.formData.episodesUnlocked && this.formData.episodesUnlocked > 0
            ? this.formData.episodesUnlocked
            : 1
        )
        this.$set(
          this.formData,
          'dailyLimit',
          this.formData.dailyLimit && this.formData.dailyLimit > 0
            ? this.formData.dailyLimit
            : 1
        )
      }
    },
    validateUnlockRewardConfig() {
      if (this.formData.type !== 4 || this.formData.rewardType !== 2) return true

      if (
        !this.formData.adsRequired ||
        this.formData.adsRequired < 1 ||
        !this.formData.episodesUnlocked ||
        this.formData.episodesUnlocked < 1 ||
        !this.formData.dailyLimit ||
        this.formData.dailyLimit < 1
      ) {
        this.$Message.error('请完善解锁短剧配置')
        return false
      }

      return true
    },
    syncDramaRecommendations(recommendCount, recommendType) {
      const totalCount =
        this.formData.popupStyle === 1 ? 1 : Number(recommendCount || 1)
      const currentRecommendations = Array.isArray(
        this.formData.recommendations
      )
        ? this.formData.recommendations
        : []
      this.formData.recommendations = Array.from(
        { length: totalCount },
        (_, index) => {
          const currentItem = currentRecommendations[index] || {}
          const recommendation = this.createDramaRecommendation(
            recommendType,
            currentItem
          )
          if (recommendType !== 2) {
            recommendation.parentPlayId = ''
            recommendation.parentPlayName = ''
          }
          return recommendation
        }
      )
      this.formData.recommendCount = totalCount
      this.dramaOptions = this.mergeDramaOptions(
        this.dramaOptions,
        currentRecommendations
      )
    },
    resetDramaSelections(
      recommendType,
      recommendCount = this.formData.recommendCount
    ) {
      const totalCount =
        this.formData.popupStyle === 1 ? 1 : Number(recommendCount || 1)
      this.formData.recommendations = Array.from({ length: totalCount }, () =>
        this.createDramaRecommendation(recommendType)
      )
      this.formData.recommendCount = totalCount
      this.languageCards = []
      // this.$nextTick(() => {
      //   if (this.$refs.formRef) {
      //     this.$refs.formRef.clearValidate()
      //   }
      // })
    },
    handleDramaStyleChange(val) {
      if (val === 1) {
        this.formData.recommendCount = 1
      }
      this.resetDramaSelections(
        this.activeDramaRecommendType,
        this.formData.recommendCount
      )
    },
    handleRecommendTypeChange(val) {
      this.resetDramaSelections(val, this.formData.recommendCount)
    },
    handleRecommendTypeChangeOnRow(index, val) {
      this.resetDramaSelections(val, this.formData.recommendCount)
    },
    handleRecommendCountChange(val) {
      this.syncDramaRecommendations(val, this.activeDramaRecommendType)
    },
    searchDramas: debounce(async function (query) {
      this.searchLoading = true
      try {
        const { data } = await getPlayList({
          current: 1,
          size: 10000,
          keyword: query
        })
        const options = (data.records || []).map((item) => ({
          id: item.id,
          name: item.playName
        }))
        this.dramaOptions = this.mergeDramaOptions(this.dramaOptions, [
          ...options,
          ...(this.formData.recommendations || [])
        ])
      } catch (e) {
        this.$Message.error('搜索剧目失败')
      } finally {
        this.searchLoading = false
      }
    }, 500),
    previewCompositePopup() {
      const { popupFileUrl, buttonFileUrl, popupSize } = this.formData
      if (!popupFileUrl) {
        this.$Message.warning('暂无背景图可预览')
        return
      }

      // Dimensions based on popup size
      const bgWidth = popupSize === 1 ? 600 : 480
      const bgHeight = popupSize === 1 ? 800 : 640
      const buttonWidth = popupSize === 1 ? 520 : 420
      const buttonHeight = popupSize === 1 ? 98 : 98
      const gap = 10 // Gap between background and button
      const bgImg = new Image()
      bgImg.crossOrigin = 'anonymous'
      bgImg.onload = () => {
        if (buttonFileUrl) {
          const btnImg = new Image()
          btnImg.crossOrigin = 'anonymous'
          btnImg.onload = () => {
            // Canvas height = background + gap + button
            const canvasHeight = bgHeight + gap + buttonHeight
            const canvas = document.createElement('canvas')
            canvas.width = bgWidth
            canvas.height = canvasHeight
            const ctx = canvas.getContext('2d')

            // Draw background at top
            ctx.drawImage(bgImg, 0, 0, bgWidth, bgHeight)

            // Draw button below background (centered horizontally)
            const btnX = (bgWidth - buttonWidth) / 2
            const btnY = bgHeight + gap
            ctx.drawImage(btnImg, btnX, btnY, buttonWidth, buttonHeight)

            const compositeImage = canvas.toDataURL('image/png')
            this.$viewerApi({ images: [compositeImage] })
          }
          btnImg.onerror = () => {
            // Only show background if button fails
            const canvas = document.createElement('canvas')
            canvas.width = bgWidth
            canvas.height = bgHeight
            const ctx = canvas.getContext('2d')
            ctx.drawImage(bgImg, 0, 0, bgWidth, bgHeight)
            const compositeImage = canvas.toDataURL('image/png')
            this.$viewerApi({ images: [compositeImage] })
          }
          btnImg.src = buttonFileUrl
        } else {
          // No button, just show background
          const canvas = document.createElement('canvas')
          canvas.width = bgWidth
          canvas.height = bgHeight
          const ctx = canvas.getContext('2d')
          ctx.drawImage(bgImg, 0, 0, bgWidth, bgHeight)
          const compositeImage = canvas.toDataURL('image/png')
          this.$viewerApi({ images: [compositeImage] })
        }
      }
      bgImg.onerror = () => {
        this.$Message.error('图片加载失败')
      }
      bgImg.src = popupFileUrl
    },
    addDramaToCard(cardIndex) {
      if (this.readonly) return
      this.languageCards[cardIndex].dramas.push(this.createEmptyDrama())
    },
    removeDramaFromCard(cardIndex, dramaIndex) {
      if (this.readonly) return
      if (this.languageCards[cardIndex].dramas.length <= 1) {
        this.$Message.warning('至少保留一项')
        return
      }
      this.languageCards[cardIndex].dramas.splice(dramaIndex, 1)
    },
    removeLanguageCard(cardIndex) {
      if (this.readonly) return
      this.languageCards.splice(cardIndex, 1)
    },
    addItem() {
      if (this.readonly) return
      const maxCount = this.languageList.length
        ? Math.min(this.languageList.length, 12)
        : 12
      if (this.languageCards.length >= maxCount) {
        this.$Message.warning(`最多只能添加${maxCount}个语言卡片`)
        return
      }
      this.languageCards.push(this.createLanguageCard())
    },
    handleCancel() {
      this.visible = false
    },
    async fetchGoods() {
      if (this.formData.type !== 1) return

      const { deviceSys, goodsType } = this.formData
      if (deviceSys === -1 || deviceSys === null || goodsType === null) {
        this.paymentOptions = []
        return
      }

      this.goodsLoading = true
      try {
        const { data } = await getGoodsList({
          current: -1,
          size: -1,
          goodsType: goodsType,
          goodsChannel: deviceSys,
          goodsVersion: 1,
          goodsStatus: 0,
        })
        this.paymentOptions = data.records || []
      } catch (e) {
        this.$Message.error('获取付费项失败')
      } finally {
        this.goodsLoading = false
      }
    },
    buildRecommendPlayContentPayload() {
      return this.languageCards
        .filter((card) => card.langId)
        .map((card) => ({
          langId: card.langId,
          parentPlayIds: card.dramas
            .filter((drama) => drama.id)
            .map((drama) => ({
              parentPlayId: drama.id,
              createTime: drama.createTime || this.getCurrentTimeString()
            }))
        }))
        .filter((card) => card.parentPlayIds.length)
    },
    buildDramaPopupPayload(payload) {
      const recommendType = this.activeDramaRecommendType
      const recommendCount =
        this.formData.popupStyle === 1 ? 1 : this.formData.recommendCount
      const isCenterPopup = this.formData.popupStyle === 1
      const isSpecifiedDrama = recommendType === 2

      payload.recommendType = recommendType
      payload.recommendCount = recommendCount
      payload.recommendPlayContent =
        recommendType === 1 ? this.buildRecommendPlayContentPayload() : []

      if (isCenterPopup) {
        const recommendation =
          this.formData.recommendations[0] ||
          this.createDramaRecommendation(recommendType)
        payload.parentPlayId =
          isSpecifiedDrama && recommendation.parentPlayId
            ? recommendation.parentPlayId
            : null
        payload.playPromotionCoverId =
          isSpecifiedDrama && recommendation.playPromotionCoverId
            ? recommendation.playPromotionCoverId
            : null
        payload.playContent = null
      } else {
        payload.parentPlayId = null
        payload.playPromotionCoverId = null
        payload.playContent = isSpecifiedDrama
          ? Array.from({ length: recommendCount }, (_, index) => {
              const recommendation =
                this.formData.recommendations[index] ||
                this.createDramaRecommendation(recommendType)
              return {
                parentPlayId: recommendation.parentPlayId || null,
                recommendType
              }
            })
          : null
      }
    },
    handleSubmit() {
      try {
        this.$refs.formRef.validate(async (valid) => {
          if (valid) {
            this.loading = true
            try {
              if (!this.validateUnlockRewardConfig()) {
                this.loading = false
                return
              }

              const payload = { ...this.formData }
              delete payload.type
              delete payload.recommendations
              delete payload.popupFileUrl
              delete payload.buttonFileUrl
              payload.popupType = this.formData.type
              
              if (this.formData.type === 2) {
                this.buildDramaPopupPayload(payload)
              } else {
                payload.recommendType = null
                payload.recommendCount = null
                payload.parentPlayId = null
                payload.playContent = null
                payload.recommendPlayContent = null
                payload.playPromotionCoverId = null
              }

              if (this.formData.type === 4) {
                if (this.formData.rewardType === 1) {
                  payload.adsRequired = null
                  payload.episodesUnlocked = null
                  payload.dailyLimit = null
                } else if (this.formData.rewardType === 2) {
                  payload.coinAmount = null
                }
              } else {
                payload.adsRequired = null
                payload.episodesUnlocked = null
                payload.dailyLimit = null
              }

              if (!payload.id) {
                delete payload.id
              }

              if (this.formData.type === 1 && this.formData.goodsType === 0) {
                payload.discountStyle = null
              }

              const apiFunc = this.formData.id ? editPopup : addPopup
              await apiFunc(payload)
              this.$Message.success('保存成功')
              this.visible = false
              this.$emit('on-success')
            } catch (error) {
              console.error('保存失败的原因:', error)
              this.$Message.error('保存失败: ' + (error.message || '未知错误'))
            } finally {
              this.loading = false
            }
          }
        })
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style scoped lang="less">
.recommendation-item {
  border: 1px dashed #dcdee2;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  background: #fdfdfd;

  .recommendation-header {
    font-weight: bold;
    margin-bottom: 10px;
    color: #464c5b;
  }
}

.preview-container {
  border-radius: 4px;
  padding: 10px;
  text-align: left;

  .preview-img {
    max-width: 150px;
    height: auto;
    display: block;
  }
}

.upload-placeholder {
  border: 1px dashed #dcdee2;
  border-radius: 4px;
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: #fafafa;
  color: #999;
  &:hover {
    border-color: #2d8cf0;
    color: #2d8cf0;
  }
}

.incentive-preview-wrapper {
  position: relative;
  background: #f0f0f0;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  .preview-bg {
    width: 100%;
    flex: 1;
    min-height: 0;
    object-fit: contain;
    display: block;
    z-index: 1;
  }

  .preview-placeholder {
    width: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ccc;
    z-index: 1;
  }

  .preview-btn-overlay {
    position: relative;
    left: auto;
    transform: none;
    z-index: 2;
    margin-bottom: 10px;

    .preview-btn-img {
      width: 100%;
      display: block;
    }
  }
}
</style>